import { CommercialRoles } from "@prisma/client";
import { z } from "zod";

const COMMERCIAL_ACCOUNT_IDENTIFIER_LENGTH = 10;
const COMMERCIAL_ACCOUNT_PASSWORD_MIN_LENGTH = 8;

const createOnlyRoleEnum = z.enum([
  CommercialRoles.commercial,
  CommercialRoles.guest,
]);

const allRolesEnum = z.nativeEnum(CommercialRoles);

const identifierSchema = z
  .string()
  .length(
    COMMERCIAL_ACCOUNT_IDENTIFIER_LENGTH,
    `L'identifiant doit contenir exactement ${COMMERCIAL_ACCOUNT_IDENTIFIER_LENGTH} caractères`,
  );

const passwordSchema = z
  .string()
  .min(
    COMMERCIAL_ACCOUNT_PASSWORD_MIN_LENGTH,
    `Le mot de passe doit contenir au moins ${COMMERCIAL_ACCOUNT_PASSWORD_MIN_LENGTH} caractères`,
  );

export const createCommercialAccountSchema = z.object({
  firstName: z.string().min(1, "Le prénom est requis"),
  lastName: z.string().min(1, "Le nom est requis"),
  identifier: identifierSchema,
  password: passwordSchema,
  commercialRole: createOnlyRoleEnum,
  jobTitle: z.string().min(1, "La fonction est requise"),
});

export const updateCommercialAccountSchema = z.object({
  firstName: z.string().min(1).optional(),
  lastName: z.string().min(1).optional(),
  identifier: identifierSchema.optional(),
  password: passwordSchema.optional().or(z.literal("")),
  email: z.string().email("Email invalide").optional().or(z.literal("")),
  commercialRole: allRolesEnum.optional(),
  jobTitle: z.string().min(1).optional(),
});

export const bulkCreateCommercialAccountsSchema = z.object({
  commercials: z.array(createCommercialAccountSchema).min(1),
});

export type CreateCommercialAccountForm = z.infer<
  typeof createCommercialAccountSchema
>;

export type UpdateCommercialAccountForm = z.infer<
  typeof updateCommercialAccountSchema
>;

export type BulkCreateCommercialAccountsForm = z.infer<
  typeof bulkCreateCommercialAccountsSchema
>;

export const defaultCreateCommercialAccountValues: CreateCommercialAccountForm = {
  firstName: "",
  lastName: "",
  identifier: "",
  password: "",
  commercialRole: CommercialRoles.commercial,
  jobTitle: "",
};
